import React, {Component} from 'react';
import {Checkbox, FormControlLabel} from "@material-ui/core";
import {CheckboxProps} from "@material-ui/core/Checkbox";

import "./luiss_checkbox.scss";

class LuissCheckbox extends Component<CheckboxProps & {label: string}> {

    render() {
        return (
            <FormControlLabel className="luiss-checkbox"
                control={
                    <Checkbox
                              icon={
                                  <div className="checkbox" />
                              }
                              checkedIcon={
                                  <div className="checkbox checked" />
                              }
                              color="primary"
                              {...this.props}
                    />
                }
                label={this.props.label}
            />
        );
    }

}

export default LuissCheckbox;